module.exports = __webpack_public_path__ + "media/packs/site/assets/images/combook_binding/sample_memo-100ae7bbe0ed72fda6896dfa486f3a9b.jpg";